import { render, staticRenderFns } from "./Page_3.vue?vue&type=template&id=6973aec7&scoped=true&"
import script from "./Page_3.vue?vue&type=script&lang=js&"
export * from "./Page_3.vue?vue&type=script&lang=js&"
import style0 from "./Page_3.vue?vue&type=style&index=0&id=6973aec7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6973aec7",
  null
  
)

export default component.exports